import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { unsubscribeUser } from "../actions/user";
import Loading from "../components/Loading";
import Button from "../components/Button";
import Alert from "../components/Alert";

const mapDispatchToProps = (dispatch) => ({
  unsubscribeUser: (key) => dispatch(unsubscribeUser(key)),
});

const ERRORS = {
  "key-is-expired-or-invalid": "Unsubscribe link is expired or invalid",
};

function Unsubscribe(props) {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState(false);
  function unSubscribe() {
    const { key } = props.match.params;
    setLoading(true);

    props.unsubscribeUser(key).then((action) => {
      if (action.error) {
        const { error } = action.error.response.data;
        setError(ERRORS[error]);
      } else {
        setOk(true);
      }
      setLoading(false);
    });
  }

  return (
    <div className="max-w-7xl mt-3">
      <h1 className="text-2xl mb-3">Unsubscribe from emails</h1>
      {error ? <Alert color="danger">{error}</Alert> : null}
      {ok ? <Alert color="success">Unsubscribed</Alert> : null}
      {!ok && (
        <Button disabled={loading} onClick={unSubscribe}>
          Unsubscribe
          {loading && (
            <div className="text-center ml-1 relative top-0.5">
              <Loading />
            </div>
          )}
        </Button>
      )}
    </div>
  );
}

Unsubscribe.propTypes = {
  match: PropTypes.any,
  unsubscribeUser: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(Unsubscribe);
